import { render, staticRenderFns } from "./VTSelbstComponent.vue?vue&type=template&id=528eacec&scoped=true"
import script from "./VTSelbstComponent.vue?vue&type=script&lang=js"
export * from "./VTSelbstComponent.vue?vue&type=script&lang=js"
import style0 from "./VTSelbstComponent.vue?vue&type=style&index=0&id=528eacec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528eacec",
  null
  
)

export default component.exports